import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './VerifiedInfo.css';

// Component
import Accounts from './Accounts';
import Loader from '../Loader';

// Locale
import messages from '../../locale/messages';
import { withQuery } from '../../hoc/withGraphql';
import { getUserVerifiedInfo } from '../../lib/graphql';

const VerifiedInfo = (props) => {
  const { userId, verifiedInfoData, showOwnProfile, hideMoreVerification } = props;
  const { formatMessage } = useIntl();
  const account = useSelector((state) => state.account.data);

  const { loading, getUserVerifiedInfo } = verifiedInfoData || {};
  const isLoggedInUser = account?.userId === userId;

  const template = (content) => (
    <div>
      <h3 className={s.titleText}>{formatMessage(messages.verifiedInfo)}</h3>
      {content}
    </div>
  );

  if (loading) {
    return template(<Loader type="text" />);
  }

  return template(
    <Accounts
      items={getUserVerifiedInfo}
      isLoggedInUser={isLoggedInUser}
      showOwnProfile={showOwnProfile}
      hideMoreVerification={hideMoreVerification}
    />
  );
};

VerifiedInfo.propTypes = {
  userId: PropTypes.string,
  showOwnProfile: PropTypes.bool,
  hideMoreVerification: PropTypes.bool,
  verifiedInfoData: PropTypes.shape({
    loading: PropTypes.bool,
    getUserVerifiedInfo: PropTypes.object,
  }),
};

VerifiedInfo.defaultProps = {
  verifiedInfoData: {
    loading: true,
  },
};


export default withStyles(s)(
  withQuery(getUserVerifiedInfo, {
    name: 'verifiedInfoData',
    options: (props) => ({
      variables: {
        userId: props.userId,
      },
      fetchPolicy: 'network-only',
      ssr: false,
    }),
  })(VerifiedInfo)
);